<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    '$route'() {
      if (window._czc) {
        const location = window.location
        const contentUrl = location.pathname + location.hash
        const refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  },
  mounted() {
    const script = document.createElement('script')
    script.src = 'https://s9.cnzz.com/z_stat.php?id=1278072740&web_id=1278072740"'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  height: 100%;

}

html,body,#app{
  height: 100%;
  margin: 0px;
  justify-content: center;
  align-items: center;

}

*{
  margin:0;
  padding:0;
}
html,body{
  width:100%;
  height:100%;
}
ul{list-style:none}
a{text-decoration: none;}
img{vertical-align:top;border:none}

.clearf:after,
.clearf:before{
  content:"";
  display:block;
  clear:both;
}
</style>



// WEBPACK FOOTER //
// src/App.vue